import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Container from 'components/Container';
import Modal from 'components/Modal';
import Notice from 'components/Notice';
import OnlyClient from 'components/OnlyClient';

import UsersPropTypes from 'utils/propTypes/users';

const withAuthorization = ({ text, onButtonClick }) => (WrappedComponent) => {
	const WithAuthorization = ({ onClick, ...props }) => {
		const [showModal, setShowModal] = useState(false);
		const { currentUser } = useSelector((state) => state.currentUser);

		const onClickHandler = useCallback(() => {
			if (currentUser) {
				onClick?.();
			} else {
				setShowModal(true);
			}
		}, [!!currentUser, onClick]);

		const onAuthButtonClick = useCallback(() => {
			onButtonClick();

			window.location.href = `/authorization/login?returnTo=${window.location.href}`;
		}, [onButtonClick]);

		const closeModal = useCallback(() => {
			setShowModal(false);
		}, []);

		const renderModal = () => (
			<OnlyClient>
				<Modal
					onRequestClose={closeModal}
					modifierClass="minimalism"
					theme="transparent"
				>
					<Container>
						<Notice
							text={text}
							controls={[
								{
									text: 'Отмена',
									onClick: closeModal,
									mute: true
								},
								{
									text: 'Войти',
									onClick: onAuthButtonClick
								}
							]}
						/>
					</Container>
				</Modal>
			</OnlyClient>
		);

		return (
			<>
				<WrappedComponent {...props} onClick={onClickHandler} />
				{showModal && renderModal()}
			</>
		);
	};

	WithAuthorization.propTypes = {
		currentUser: UsersPropTypes.user,
		onClick: PropTypes.func
	};

	return WithAuthorization;
};

export default withAuthorization;
